export default (urlParameters) => {
  return {
    pro_forecast: {
      pro_forecast_id: urlParameters.pro_forecast_id,
    }
  }
}